/**
 * Status values for individual checks.
 */
export const CHECK_STATUS = {
  PASS: 'pass',
  AT_RISK: 'at_risk',
  FAIL: 'fail',
  RUNNING: 'running',
  SKIPPED: 'skipped', // for checks infeasible in browser context
};

/**
 * Overall readiness status derived from all check results.
 */
export const OVERALL_STATUS = {
  READY: 'Ready',
  AT_RISK: 'At-Risk',
  NOT_READY: 'Not-Ready',
};

// Any FAIL → Not-Ready; any AT_RISK → At-Risk; else → Ready. SKIPPED/RUNNING ignored.
export function computeOverallStatus(results) {
  let hasAtRisk = false;

  for (const result of results) {
    if (result.status === CHECK_STATUS.FAIL) {
      return OVERALL_STATUS.NOT_READY;
    }
    if (result.status === CHECK_STATUS.AT_RISK) {
      hasAtRisk = true;
    }
  }

  return hasAtRisk ? OVERALL_STATUS.AT_RISK : OVERALL_STATUS.READY;
}
